export namespace Classnames {
  export const CONFIG_MAIN_PANEL = 'CBridge-config-panel-main';
  export const CONFIG_NAV_PANEL = 'CBridge-config-panel CBridge-config-panel-nav';
  export const CONFIG_DETAILS_PANEL = 'CBridge-config-panel CBridge-config-panel-details';
  export const CONFIG_PANEL_RESIZER = 'CBridge-config-panel-resizer';
  export const VISIBLE_ON_HOVER = 'CBridge-visible-on-hover';
  export const GRID_ODD_ROW = 'MuiDataGrid-odd-row';
  export const MASTER_ROW = 'MuiDataGrid-master-row';
  export const DISABLED_ROW = 'MuiDataGrid-disabled-row';
  export const GRAYED_ROW = 'MuiDataGrid-grayed-row';
  export const ADDED_ROW = 'MuiDataGrid-added-row';
  export const UPDATED_ROW = 'MuiDataGrid-updated-row';
  export const DELETED_ROW = 'MuiDataGrid-deleted-row';
  export const SUBTOTAL_ROW = 'MuiDataGrid-subtotal-row';
  export const TREE_GROUP_ROW = 'MuiDataGrid-tree-group-row';
  export const EQUAL_CELL_VALUES = 'MuiDataGrid-cell--equalValues';
  export const AUTOCOMPLETE_GROUP_LABEL = 'MuiAutocomplete-groupLabel';
}

export const CbridgePalette = {
  // Background colors
  background: {
    main: '#14181D',
    sideBar: '#1A1F25',
    tableRow: '#1C2025',
    h1: '#292E35',
    h2: '#22262B',
    tooltips: '#373C42',
    selection: '#F2F3FF12',
  },

  divider: '#F2F3FF1A',

  primary: {
    main: '#EEF0FF',
  },

  text: {
    primary: '#F2F3FF',
    secondary: '#F2F3FFB2',
    tertiary: '#BDBDBD',
    disabled: '#F2F3FF52',
  },

  icon: {
    secondary: '#F2F3FF80',
  },

  accent: '#51319A',
  warning: '#E2B037',
  success: '#4CCB76',
  info: '#83D0F1',
  error: {
    main: '#C14151',
    light: '#B63C49',
  },

  hoverOverlay: '#F2F3FF 5%',
  focusOverlay: '#F2F3FF 10%',
  focusBorder: '#FFFFFF 20%',

  border: '#FFFFFF33',

  button: {
    text: {
      main: '#FFFFFFCC',
      pressed: '#F2F3FF80',
      disabled: '#F2F3FF52',
    },

    primary: {
      main: '#51319A',
      active: '#3D1F82',
      disabled: '#8158D933',
    },
    secondary: {
      main: '#F2F3FF1A',
      active: '#FFFFFF0D',
      disabled: '#F2F3FF0D',
    },
    error: {
      main: '#C14151',
      active: '#B43B4D',
      disabled: '#B43B4D66',
    },
  },

  switch: {
    on: {
      main: {
        track: '#7C4DFF',
        thumb: '#F2F3FF',
      },
      active: {
        track: '#7C4DFF',
        thumb: '#FFFFFF',
      },
      disabled: {
        track: '#4B3692',
        thumb: '#868992',
      },
    },

    off: {
      main: {
        track: '#FFFFFF61',
        thumb: '#AFB1BB',
      },
      active: {
        track: '#FFFFFF61',
        thumb: '#FFFFFF',
      },
      disabled: {
        track: '#FFFFFF61',
        thumb: '#868992',
      },
    },
  },

  // Action colors
  action: {
    active: '#FFFFFF56',
  },

  // DataGrid colors
  dataGrid: {
    normal: {
      odd: {
        default: '#14181D',
        hover: '#272B30',
        selected: '#2B2F34',
        selectedHover: '#2B2F34',
      },
      even: {
        default: '#1C2025',
        hover: '#272B30',
        selected: '#2B2F34',
        selectedHover: '#2B2F34',
      },
    },
    added: {
      odd: 'color-mix(in srgb, #292D33, #4CCB76 10%)',
      even: 'color-mix(in srgb, color-mix(in srgb, #292D33, #4CCB76 10%), #F2F3FF 5%)',
      hover: 'color-mix(in srgb, color-mix(in srgb, #292D33, #4CCB76 10%), #F2F3FF 10%)',
    },
    deleted: {
      odd: 'color-mix(in srgb, #292D33, #E8485C 10%)',
      even: 'color-mix(in srgb, color-mix(in srgb, #292D33, #E8485C 10%), #F2F3FF 5%)',
      hover: 'color-mix(in srgb, color-mix(in srgb, #292D33, #E8485C 10%), #F2F3FF 10%)',
    },
    updated: {
      odd: 'color-mix(in srgb, #292D33, #E2B037 10%)',
      even: 'color-mix(in srgb, color-mix(in srgb, #292D33, #E2B037 10%), #F2F3FF 5%)',
      hover: 'color-mix(in srgb, color-mix(in srgb, #292D33, #E2B037 10%), #F2F3FF 10%)',
    },

    masterRowBg: '#444A4F',
    primaryStatesSelected: '#90CAF920',
    masterRowHover: 'rgba(144, 202, 249, 0.20)',
    disabledRowBg: 'rgba(255, 255, 255, 0.12)',
  },

  // Scrollbar colors
  scrollbar: {
    thumb: '#757575',
  },

  // Dialog colors
  dialog: {
    paperBg: '#333940',
  },

  // Autocomplete colors
  autocomplete: {
    groupLabelBg: '#393F47',
  },

  badge: {
    disabledBg: 'rgba(255, 255, 255, 0.16)',
    error: '#E8485C',
  },

  chip: {
    trading: '#69D061',
  },

  risk: {
    critical: {
      text: '#EF5350',
      bg: '#C1415133',
    },
    high: {
      text: '#FF6F00',
      bg: '#E8A45A26',
    },
    medium: {
      text: '#FFC107',
      bg: '#FFD95D33',
    },
    low: {
      text: '#93C5FD',
      bg: '#93C5FD26',
    },
    all: {
      text: '#F2F3FF',
      bg: '#F2F3FF1A',
    },
  },
};
